module.exports = __webpack_public_path__ + "img/Training-Unsel.01135dc9.svg";